export const encodeBase64 = (data: ArrayBuffer): string => {
  return btoa(String.fromCharCode(...new Uint8Array(data)));
};

export const uint8ArrayToBase64 = (uint8Array: Uint8Array): string => {
  let binary = "";
  for (let i = 0; i < uint8Array.length; i++) {
    binary += String.fromCharCode(uint8Array[i]);
  }
  return btoa(binary);
};

export const decodeBase64 = (base64: string): ArrayBuffer => {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
};

export const encryptPayload = async (
  key: CryptoKey,
  iv: Uint8Array,
  payload: object
): Promise<ArrayBuffer> => {
  const encoder = new TextEncoder();
  const encoded = encoder.encode(JSON.stringify(payload));

  return crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv: iv,
    },
    key,
    encoded
  );
};

export const decryptPayload = async (
  key: CryptoKey,
  ivBase64: string,
  encryptedBase64: string
): Promise<unknown> => {
  const iv = new Uint8Array(decodeBase64(ivBase64));
  const encryptedData = decodeBase64(encryptedBase64);

  const decryptedBuffer = await crypto.subtle.decrypt(
    {
      name: "AES-GCM",
      iv: iv,
    },
    key,
    encryptedData
  );

  const decoder = new TextDecoder();
  const decodedText = decoder.decode(decryptedBuffer);
  // return JSON.parse(decodedText);
  return decodedText;
};

export const importKeyFromBase64 = async (
  keyBase64: string
): Promise<CryptoKey> => {
  const rawKey = decodeBase64(keyBase64);
  return importKeyFromArrayBuffer(rawKey);
};

export const importKeyFromArrayBuffer = async (
  arrayBuffer: ArrayBuffer
): Promise<CryptoKey> => {
  return crypto.subtle.importKey(
    "raw",
    arrayBuffer,
    { name: "AES-GCM" },
    true,
    ["decrypt", "encrypt"]
  );
};

export const generateKeyIv = async () => {
  const key = await crypto.subtle.generateKey(
    {
      name: "AES-GCM",
      length: 256,
    },
    true,
    ["encrypt"]
  );

  const exportedKey = await crypto.subtle.exportKey("raw", key); // Export as ArrayBuffer
  const keyBase64 = encodeBase64(exportedKey); // Your existing encodeBase64 function
  const iv = crypto.getRandomValues(new Uint8Array(12)); // 96-bit IV for AES-GCM

  return { key, keyBase64, iv };
};

export const keyFromBase64 = async (keyBase64: string): Promise<CryptoKey> => {
  const rawKey = decodeBase64(keyBase64); // Convert to ArrayBuffer
  return crypto.subtle.importKey("raw", rawKey, { name: "AES-GCM" }, true, [
    "decrypt",
  ]);
};
